import { NA_MESSAGE } from "../../ui/constants";

export const valueOrNA = (value: string | number | undefined) => {
  return value ?? NA_MESSAGE;
};
